angular.module('vppApp', ['ui.router', 'vppApp.constants', 'ngTouch', 'ngMessages', 'ngAria', 'vAccordion', 'ngAnimate', 'base64', 'ngSanitize', 'ngCookies']);

angular
  .module('vppApp')
  .config(function ($stateProvider, $urlRouterProvider, $locationProvider, $rootScopeProvider, $httpProvider, $urlMatcherFactoryProvider, $compileProvider) {
    //make trailing slashes optional
    $urlRouterProvider.rule(function ($injector, $location) {
      var path = $location.url();

      // check to see if the path already has a slash where it should be
      if (path[path.length - 1] === '/' || path.indexOf('/?') > -1) {
        return;
      }

      if (path.indexOf('?') > -1) {
        return path.replace('?', '/?');
      }

      if (path.indexOf('/#!') > -1) {
        return path.replace('/#!', '/');
      }

      if (path.indexOf('/#') > -1) {
        return path.replace('/#', '/');
      }

      if (path.indexOf('saml') > -1 && path.indexOf('login') > -1) {
        $injector.get('SamlLogin').login();
        return;
      } else {
        return path + '/';
      }

    });

    // For any unmatched url, send to 404
    $urlRouterProvider.otherwise('/404');

    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|javascript|mailto):/);
    $locationProvider.html5Mode(true).hashPrefix('!');
    $httpProvider.defaults.headers.common['Cache-Control'] = 'no-cache';
    $httpProvider.defaults.cache = false;

    if (!$httpProvider.defaults.headers.get) {
      $httpProvider.defaults.headers.get = {};
    }
    $httpProvider.defaults.headers.get['If-Modified-Since'] = '0';
    // $urlMatcherFactoryProvider.strictMode(false);

    $stateProvider
      .state('index', {
        url: '/',
        pageTitle: 'New Car Discounts',
        metaDescription: 'Learn how your discount can be applied to the purchase or lease of a Chevrolet, Buick or GMC.',
        pageID: '',
        canonical: domainPath,
        views: {
          '': {
            templateUrl: '/non-content/templates/row-three.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'brandBar-secondary': {
            templateUrl: '/non-content/components/brand-bar-secondary.html',
            controller: 'brandBarSecondaryController',
            controllerAs: 'BBCS'
          },
          'brandBar-sso': {
            templateUrl: '/non-content/components/brand-bar-sso.html',
            controller: 'brandBarSSOController',
            controllerAs: 'BBCS'
          },
          'row-one@index': {
            templateUrl: '/non-content/components/slider.html',
            controller: 'sliderController',
            controllerAs: 'SC'
          },
          'row-two@index': {
            templateUrl: '/non-content/components/teaser.html',
            controller: 'teaserController',
            controllerAs: 'HTC'
          },
          'row-three@index': {
            templateUrl: '/non-content/components/promo-tile.html',
            controller: 'promoTileController',
            controllerAs: 'HPC'
          }
        }
      })
      .state('home', {
        url: '/home/',
        pageTitle: '',
        pageID: '',
        resolve: {
          redirect: ['$location', function ($location) {
            $location.path('/')
          }]
        },
        views: {
          'subNav': {
            templateUrl: '/content/html/partials/global/nav-subnav.html'
          }
        }
      })
      .state('404', {
        url: '/404/',
        pageTitle: '',
        pageID: '',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'row-one@404': {
            templateUrl: '/content/html/partials/global/404.html'
          }
        }
      })
      .state('about-discount', {
        url: '/about-the-discount/',
        pageTitle: 'About the Discount',
        metaDescription: 'Answers to some of your most frequently asked questions about the GM Discount.',
        pageID: '',
        canonical: domainPath + "/about-the-discount/",
        views: {
          '': {
            templateUrl: '/non-content/templates/row-four.html'
          },
          'subNav': {
            templateUrl: '/content/html/partials/global/nav-subnav.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'brandBar-sub': {
            templateUrl: '/non-content/components/teaser.html',
            controller: 'teaserController',
            controllerAs: 'ATC'
          },
          'row-one@about-discount': {
            templateUrl: '/non-content/components/content.html',
            controller: 'contentController',
            controllerAs: "ECC"
          },

          //company eligigiblity
          'row-two@about-discount': {
            templateUrl: function () {
              if (domainAbbr === 'sup') {
                return '/non-content/components/companySearch.html';
              }
              if (domainAbbr === 'emp') {
                return '/non-content/components/content-two.html';
              }
            },
            controllerProvider: function () {
              if (domainAbbr === 'sup') {
                return 'companyController';
              }
              if (domainAbbr === 'emp') {
                return 'contentTwoController';
              }
            }
          },
          //faqs accordion component
          'row-three@about-discount': {
            templateUrl: '/non-content/components/contentAccordion.html',
            controller: 'contentAccordionController',
            controllerAs: "FAC"
          },
          'row-four@about-discount': {
            templateUrl: '/content/html/partials/rules/' + domainAbbr + '/rules.html'
          }
        }
      })
      .state('about-offer', {
        url: '/about-the-offer/',
        pageTitle: 'About the Discount',
        metaDescription: 'Answers to some of your most frequently asked questions about the GM Discount.',
        pageID: '',
        canonical: domainPath + "/about-the-offer/",
        views: {
          '': {
            templateUrl: '/non-content/templates/row-four.html'
          },
          'subNav': {
            templateUrl: '/content/html/partials/global/nav-subnav.html'
          },

          'brandBar': {
            templateUrl: '/content/html/partials/global/brandbar-about.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'brandBar-sub': {
            templateUrl: '/non-content/components/teaser.html',
            controller: 'teaserController',
            controllerAs: 'ATC'
          },
          'row-one@about-offer': {
            templateUrl: '/non-content/components/content.html',
            controller: 'contentController',
            controllerAs: "ECC"
          },
          //company eligigiblity
          'row-two@about-offer': {
            templateUrl: function () {
              if (domainAbbr === 'sup') {
                return '/non-content/components/companySearch.html';
              }
              if (domainAbbr === 'emp') {
                return '/non-content/components/content-two.html';
              }
            },
            controllerProvider: function () {
              if (domainAbbr === 'sup') {
                return 'companyController';
              }
              if (domainAbbr === 'emp') {
                return 'contentTwoController';
              }
            }
          },
          //faqs accordion component
          'row-three@about-offer': {
            templateUrl: '/non-content/components/contentAccordion.html',
            controller: 'contentAccordionController',
            controllerAs: "FAC"
          },
          'row-four@about-offer': {
            templateUrl: '/content/html/partials/rules/' + domainAbbr + '/rules.html'
          }
        }
      })
      .state('vehicles', {
        url: '/vehicles/',
        pageTitle: 'Vehicles',
        metaDescription: 'Find out which General Motors vehicles are available with your GM Discount.',
        pageID: '',
        canonical: domainPath + "/vehicles/",
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'brandBar-sub': {
            templateUrl: '/non-content/components/content.html',
            controller: 'contentController',
            controllerAs: 'PCC'
          },
          'row-one@vehicles': {
            //templateUrl: '/non-content/components/add-componant-here.html'
            // Temporary Place holder for Row - Remove Template when ready.
            templateUrl: '/content/html/partials/offers/' + domainAbbr + '/vehicle-eligibility.html',
            controller: ''
          }
        }
      })
      .state('offers', {
        url: '/offers/',
        pageTitle: 'Offers',
        metaDescription: 'GM Discount means more than just a discount on outstanding vehicles.',
        pageID: '',
        canonical: domainPath + "/offers/",
        views: {
          '': {
            templateUrl: '/non-content/templates/row-three.html'
          },
          'subNav': {
            templateUrl: '/content/html/partials/global/nav-subnav.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'brandBar-sub': {
            templateUrl: '/non-content/components/headline.html',
            controller: 'headlineController',
            controllerAs: 'HFC',
            resolve: {
              ssoUrl: function () {
                return {};
              }
            }
          },

          'row-one@offers': {
            templateUrl: domainAbbr === 'frd' ? '/content/html/partials/global/frd-vehicle-brand-offers.html' : '/non-content/components/toggle-offers.html',
            controller: 'toggleOfferController',
            controllerAs: 'BLC'
          },

          // 'row-one@offers': {
          //   templateUrl: '/non-content/components/toggle-offers.html',
          //   controller: 'toggleOfferController',
          //   controllerAs: 'BLC'
          // },
          /*====== current offer component, hide when not working =====*/
          // 'row-two@offers': {
          //    templateUrl: '/non-content/components/currentOffers.html',
          //    controller: 'CurrentOffersController',
          //    controllerAs: 'COC'
          //  },
          /*==== temp links to brand sites, show when current offers not working ====*/
          // 'row-two@offers': {
          //    templateUrl: '/content/html/partials/global/offers-brand-links.html',
          //    controller: 'CurrentOffersController',
          //    controllerAs: 'COC'
          //  },
          /*==== temp links to brand sites with links while brand offers not available ====*/
          /*
          'row-two@offers': {
            templateUrl: '/content/html/partials/global/brand-offer-links.html',
            controller: 'brandOfferLinksController',
            controllerAs: 'BOL'
          },
          */
          'row-three@offers': {
            templateUrl: '/non-content/components/contentCards.html',
            controller: 'contentCardsController',
            controllerAs: 'OAC'
          }
          // ,
          // 'row-three@offers': {
          //   templateUrl: '/non-content/components/contentAccordion.html',
          //   controller: 'contentAccordionController',
          //   controllerAs: 'OAC'
          // }
        }
      })
      .state('shopping-tools', {
        url: '/',
        cache: false,
        abstract: true,
        pageTitle: '',
        pageID: '',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'subNav': {
            templateUrl: '/content/html/partials/global/nav-subnav.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'brandBar-sub': {
            templateUrl: '/non-content/components/headline.html',
            controller: 'headlineController',
            controllerAs: 'FFC',
            resolve: {
              ssoUrl: function () {
                return {};
              }
            }
          }

        }
      })
      .state('shopping-tools.find-dealer', {
        url: 'find-a-dealer/',
        cache: false,
        pageTitle: 'Find a Dealer',
        metaDescription: 'Find a dealership near you with the vehicle you want: see hours, contact info, and dealer website.',
        pageID: '',
        canonical: domainPath + "/find-a-dealer/",
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'subNav': {
            templateUrl: '/content/html/partials/global/nav-subnav.html'
          },
          'row-one': {
            templateUrl: '/non-content/components/find-a-dealer-form.html',
            controller: 'findDealerFormController',
            controllerAs: 'FDC'
            // Temporary Place holder for Row - Remove Template when ready.
            // template: "<div class='tempPlaceholder'>Row One Find a Dealer Content Area</div>"
          }
        }
      })
      .state('shopping-tools.find-dealer-results', {
        url: 'find-dealer-results/',
        pageTitle: 'Find a Dealer',
        pageID: '',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'subNav': {
            templateUrl: '/content/html/partials/global/nav-subnav.html'
          },
          'row-one': {
            templateUrl: '/non-content/components/find-a-dealer-results.html',
            controller: 'findDealerResultsController',
            controllerAs: 'DRC'
            // Temporary Place holder for Row - Remove Template when ready.
            // template: "<div class='tempPlaceholder'>Row One Find a Dealer Results Content Area</div>"
          }
        }
      })
      .state('shopping-tools.build', {
        url: 'build-and-price/',
        pageTitle: 'Build and Price',
        metaDescription: 'Create your ideal vehicle, then see your discounted price — before you walk into the dealership.',
        pageID: '',
        canonical: domainPath + "/build-and-price/",
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'subNav': {
            templateUrl: '/content/html/partials/global/nav-subnav.html'
          },
          'row-one': {
            templateUrl: '/content/html/partials/global/build-price.html',
            controller: 'buildPriceController',
            controllerAs: 'BPC'

          }
        }
      })
      .state('shopping-tools.finance', {
        url: 'finance/',
        pageTitle: 'Financing',
        metaDescription: 'GM gives more than just a great discount, Find out how we can make a new vehicle even more affordable for you.',
        pageID: '',
        canonical: domainPath + "/finance/",
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'subNav': {
            templateUrl: '/content/html/partials/global/nav-subnav.html'
          },
          'row-one': {
            templateUrl: '/non-content/components/content.html',
            controller: 'contentController',
            controllerAs: "ECC"
          }
        }
      })
      .state('shopping-tools.downloads', {
        url: 'brochure-downloads/',
        pageTitle: 'Brochure Download',
        metaDescription: 'Click a division below to view vehicle information or download a brochure of the vehicle(s) you’re considering. There’s a GM car, truck, SUV or crossover that’s right for you.',
        pageID: '',
        canonical: domainPath + "/brochure-downloads/",
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'subNav': {
            templateUrl: '/content/html/partials/global/nav-subnav.html'
          },
          'row-one': {
            templateUrl: '/non-content/components/brand-logos.html',
            controller: 'brandLogoController',
            controllerAs: 'BLC'
          }
        }
      })
      .state('promote', {
        url: '/',
        cache: false,
        abstract: true,
        pageTitle: '',
        pageID: '',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-four.html'
          }
        }
      })
      .state('promote.main', {
        url: 'promote/',
        pageTitle: 'Promote the Discount',
        pageID: '',
        canonical: domainPath + "/promote/",
        views: {
          'brandBar@': {

            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'subNav@': {
            templateUrl: '/content/html/partials/global/nav-subnav.html'
          },
          'row-one': {
            templateUrl: '/non-content/components/content.html',
            controller: 'contentController',
            controllerAs: 'PCC'
          },
          'row-two': {
            templateUrl: '/non-content/components/contentAccordion.html',
            controller: 'contentAccordionController',
            controllerAs: 'PAC'
          }
        }
      })
      .state('promote.supplier-tour', {
        url: 'set-up-event/',
        pageTitle: 'GM Supplier Discount Experience',
        metaDescription: "Bring the GM Supplier Discount Experience to your workplace, it is a valuable perk. Learn more about how you can host an event.",
        canonical: domainPath + "/set-up-event/",
        views: {
          '': {
            templateUrl: '/non-content/templates/row-four.html'
          },
          'subNav@': {
            templateUrl: '/content/html/partials/global/nav-subnav.html'
          },
          'row-one': {
            templateUrl: '/content/html/partials/tour/sup/tour-exp.html'
          },
          'row-two': {
            templateUrl: '/non-content/components/teaser.html',
            controller: 'teaserController',
            controllerAs: 'TTC'
          },
          'row-three': {
            templateUrl: '/content/html/partials/tour/sup/tour-min-req.html'
          },
          'row-four': {
            templateUrl: '/content/html/partials/tour/sup/tour-more-info.html'
          }
        }
      })
      .state('refer', {
        url: '/refer-friends-and-family/',
        pageTitle: '',
        pageID: '',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'row-one@refer': {
            templateUrl: '/non-content/components/row-placeholder.html'
          }
        }
      })
      .state('support', {
        url: '/resources/',
        pageTitle: 'Resources',
        metaDescription: 'GM offers a variety of programs and sponsorships on purchase or lease of a Chevrolet, Buick or GMC.',
        pageID: '',
        canonical: domainPath + "/resources/",
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'brandBar-sub': {
            templateUrl: '/non-content/components/content.html',
            controller: 'contentController',
            controllerAs: 'PCC'
          },
          'row-one@support': {
            templateUrl: '/content/html/partials/support/mpp/support.html'
          }
        }
      })
      .state('videos', {
        url: '/videos/',
        pageTitle: 'Videos',
        metaDescription: 'Watch a collection of GM discount TV clips, commercials and more.',
        pageID: '',
        canonical: domainPath + "/videos/",
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'brandBar-sub': {
            templateUrl: '/non-content/components/headline.html',
            controller: 'headlineController',
            controllerAs: 'CBBSC',
            resolve: {
              ssoUrl: function () {
                return {};
              }
            }
          },
          'row-one@videos': {
            templateUrl: '/content/html/partials/videos/' + domainAbbr + '/videos.html',
            controller: 'videoPlayerController',
            controllerAs: 'VPC'
          }
        }
      })
      .state('appreciation', {
        url: '/appreciation/',
        pageTitle: 'Appreciation',
        metaDescription: '',
        pageID: '',
        canonical: domainPath + "/appreciation/",
        views: {
          '': {
            template: '',
            controller: function ($state) {
              $state.go("appreciation." + domainAbbr);
            }
          },
          'subNav': {
            templateUrl: '/content/html/partials/global/nav-subnav.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'appreciationMasthead': {
            templateUrl: '/non-content/components/appreciationMasthead.html',
            controller: 'appreciationMastheadController'
          }
        }
      })
      .state('appreciation.gmed', {
        url: '',
        pageTitle: 'Teacher Appreciation',
        metaDescription: 'Watch the stories of five dedicated educators and how they got an unbelievable surprise from their students.',
        pageID: '',
        canonical: domainPath + "/appreciation/",
        views: {
          '@': {
            templateUrl: '/non-content/templates/row-two.html'
          },
          'subNav': {},
          'row-one@appreciation.gmed': {
            templateUrl: '/content/html/partials/videos/' + domainAbbr + '/videos.html',
            controller: 'videoPlayerController',
            controllerAs: 'VPC'
          },
          'row-two@appreciation.gmed': {
            templateUrl: '/content/html/partials/posters/' + domainAbbr + '/posters.html',
            controller: 'contentTwoController',
            controllerAs: 'APC'
          }
        }
      })
      .state('appreciation.frd', {
        url: '',
        pageTitle: 'First Responder Appreciation',
        metaDescription: '',
        pageID: '',
        canonical: domainPath + "/appreciation/",
        views: {
          '@': {
            templateUrl: '/non-content/templates/row-three.html'
          },
          'subNav': {},
          'row-one@appreciation.frd': {
            templateUrl: '/content/html/partials/videos/' + domainAbbr + '/videos.html',
            controller: 'videoPlayerController',
            controllerAs: 'VPC'
          }
        }
      })

      .state('frd-appreciation', {
        url: '/frd-appreciation/',
        pageTitle: 'First Responder Appreciation',
        metaDescription: '',
        pageID: '',
        canonical: domainPath + "/frd-appreciation/",
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'subNav': {
            templateUrl: '/content/html/partials/global/nav-subnav.html'
          },
          'row-one@frd-appreciation': {
            templateUrl: '/content/html/partials/videos/' + domainAbbr + '/videos.html',
            controller: 'videoPlayerController',
            controllerAs: 'VPC'
          }
        }
      })

      .state('appreciation.mpp', {
        url: '',
        pageTitle: 'Military Appreciation',
        metaDescription: '',
        pageID: '',
        canonical: domainPath + "/appreciation/",
        views: {
          '@': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'subNav': {},
          'row-one@appreciation.mpp': {
            templateUrl: '/content/html/partials/videos/' + domainAbbr + '/videos.html',
            controller: 'videoPlayerController',
            controllerAs: 'VPC'
          }
        }
      })

      .state('share', {
        url: '/share/',
        pageTitle: 'Share',
        pageID: '',
        canonical: domainPath + "/share/",
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'subNav': {
            templateUrl: '/content/html/partials/global/nav-subnav.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'brandBar-sub': {
            templateUrl: '/non-content/components/headline.html',
            controller: 'headlineController',
            controllerAs: 'CBBSC',
            resolve: {
              ssoUrl: function () {
                return {};
              }
            }
          },
          'row-one@share': {
            templateUrl: '/content/html/partials/share/' + domainAbbr + '/share.html',
            controller: 'shareController',
            controllerAs: 'SOC'
          }
        }
      })
      .state('sitemap', {
        url: '/site-map/',
        pageTitle: 'Site Map',
        metaDescription: 'Site map displays all the information you need to know about this discount program.',
        pageID: '',
        canonical: domainPath + "/site-map/",
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one@sitemap': {
            //templateUrl: '/non-content/components/add-componant-here.html'
            // Temporary Place holder for Row - Remove Template when ready.
            templateUrl: '/non-content/components/sitemap.html',
            controller: 'footerController',
            controllerAs: 'FOC'
          }
        }
      })
      .state('privacy-policy', {
        url: '/privacy-policy/',
        pageTitle: 'Privacy Policy',
        pageID: '',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one@privacy-policy': {
            //templateUrl: '/non-content/components/add-componant-here.html'
            // Temporary Place holder for Row - Remove Template when ready.
            template: "<div class='tempPlaceholder'>Row One Privacy Policy Content Area</div>"
          }
        }
      })
      .state('terms', {
        url: '/terms-of-service/',
        pageTitle: 'Terms of Service',
        pageID: '',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'row-one@terms': {
            //templateUrl: '/non-content/components/add-componant-here.html'
            // Temporary Place holder for Row - Remove Template when ready.
            template: "<div class='tempPlaceholder'>Row One TOS Content Area</div>"
          }
        }
      })
      .state('view-auth', {
        url: '/view-authorizations/',
        pageTitle: 'View Authorizations',
        pageID: '',
        authenticate: true,
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html',
            controller: 'viewAuthController',
            controllerAs: 'VAC'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'brandBar-sub': {
            templateUrl: '/content/html/partials/global/programHeading.html'
          },
          'row-one@view-auth': {
            templateUrl: domainAbbr == 'emp' ? '/content/html/partials/programs/emp/view-auth.html' : '/content/html/partials/programs/sup/view-auth.html'
          }
        }
      })
      .state('overview', {
        url: '/program-overview/',
        pageTitle: 'Program Overview',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one@overview': {
            templateUrl: '/content/html/partials/overviews/' + domainAbbr + '/overview.html',
            controller: 'overviewController',
            controllerAs: 'OVC'
          }
        }
      })
      .state('overview.gmsdd', {
        url: 'gmsdd/',
        pageTitle: 'Overview | GM Legacy Discount',
        programCode: 'gmsdd',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one': {
            templateUrl: '/content/html/partials/overviews/emp/gm-legacy-discount.html',
            controller: 'publicOverviewController',
            controllerAs: 'POVC'
          }
        }
      })
      .state('overview.accdisc', {
        url: 'accdisc/',
        pageTitle: 'Overview | Accessories Discount',
        programCode: 'accdisc',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one': {
            templateUrl: '/content/html/partials/overviews/emp/gm-accessory-discount.html',
            controller: 'publicOverviewController',
            controllerAs: 'POVC'
          }
        }
      })
      .state('overview.sdff2', {
        url: 'sdff2/',
        pageTitle: 'Overview | GM Supplier Discount for Friends',
        programCode: 'sdff2',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one': {
            templateUrl: '/content/html/partials/overviews/emp/gm-supplier-discount-for-friends.html',
            controller: 'publicOverviewController',
            controllerAs: 'POVC'
          }
        }
      })
      .state('overview.vts', {
        url: 'vts/',
        pageTitle: 'Overview | Vehicle Tagging',
        programCode: 'vts',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one': {
            templateUrl: '/content/html/partials/overviews/emp/company-owned-purchase.html',
            controller: 'publicOverviewController',
            controllerAs: 'POVC'
          }
        }
      })
      .state('overview.lti', {
        url: 'lti/',
        pageTitle: 'Overview | Long Term Incentive',
        programCode: 'lti',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one': {
            templateUrl: '/content/html/partials/overviews/emp/gm-employee-purchase.html',
            controller: 'publicOverviewController',
            controllerAs: 'POVC'
          }
        }
      })
      .state('overview.gms', {
        url: 'gms/',
        pageTitle: 'Overview | GM Employee Purchase',
        programCode: 'gms',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one': {
            templateUrl: '/content/html/partials/overviews/emp/gm-employee-purchase.html',
            controller: 'publicOverviewController',
            controllerAs: 'POVC'
          }
        }
      })
      .state('overview.yos5', {
        url: 'yos5/',
        pageTitle: 'Overview | GM Employee Purchase',
        programCode: 'yos5',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one': {
            templateUrl: '/content/html/partials/overviews/emp/gm-employee-purchase.html',
            controller: 'publicOverviewController',
            controllerAs: 'POVC'
          }
        }
      })
      .state('overview.yos20', {
        url: 'yos20/',
        pageTitle: 'Overview | GM Employee Purchase',
        programCode: 'yos20',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one': {
            templateUrl: '/content/html/partials/overviews/emp/gm-employee-purchase.html',
            controller: 'publicOverviewController',
            controllerAs: 'POVC'
          }
        }
      })
      .state('overview.pep', {
        url: 'pep/',
        pageTitle: 'Overview | Company Owned Purchase',
        programCode: 'pep',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one': {
            templateUrl: '/content/html/partials/overviews/emp/company-owned-purchase.html',
            controller: 'publicOverviewController',
            controllerAs: 'POVC'
          }
        }
      })
      .state('overview.pepcont', {
        url: 'pepcont/',
        pageTitle: 'Overview | Company Owned Purchase',
        programCode: 'pepcont',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one': {
            templateUrl: '/content/html/partials/overviews/emp/company-owned-purchase-pepcont.html',
            controller: 'publicOverviewController',
            controllerAs: 'POVC'
          }
        }
      })
      .state('overview.appcert1g', {
        url: 'app-cert-1/',
        pageTitle: 'Overview | Employee Appreciation Certificate',
        programCode: 'appcert1g',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one': {
            templateUrl: '/content/html/partials/overviews/emp/employee-appreciation.html',
            controller: 'publicOverviewController',
            controllerAs: 'POVC'
          }
        }
      })
      .state('overview.appcert2g', {
        url: 'app-cert-2/',
        pageTitle: 'Overview | Employee Appreciation Certificate',
        programCode: 'appcert2g',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one': {
            templateUrl: '/content/html/partials/overviews/emp/employee-appreciation.html',
            controller: 'publicOverviewController',
            controllerAs: 'POVC'
          }
        }
      })
      .state('overview.appcert3g', {
        url: 'app-cert-3/',
        pageTitle: 'Overview | Employee Appreciation Certificate',
        programCode: 'appcert3g',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one': {
            templateUrl: '/content/html/partials/overviews/emp/employee-appreciation.html',
            controller: 'publicOverviewController',
            controllerAs: 'POVC'
          }
        }
      })
      .state('overview.gmfappcert1g', {
        url: 'gmfappcert1G/',
        pageTitle: 'Overview | Employee Appreciation Certificate',
        programCode: 'gmfappcert1g',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one': {
            templateUrl: '/content/html/partials/overviews/emp/gmf-employee-appreciation.html',
            controller: 'publicOverviewController',
            controllerAs: 'POVC'
          }
        }
      })
      .state('overview.gmfappcert2g', {
        url: 'gmfappcert2G/',
        pageTitle: 'Overview | Employee Appreciation Certificate',
        programCode: 'gmfappcert2g',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one': {
            templateUrl: '/content/html/partials/overviews/emp/gmf-employee-appreciation.html',
            controller: 'publicOverviewController',
            controllerAs: 'POVC'
          }
        }
      })
      .state('overview.gmfappcert3g', {
        url: 'gmfappcert3G/',
        pageTitle: 'Overview | Employee Appreciation Certificate',
        programCode: 'gmfappcert3g',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one': {
            templateUrl: '/content/html/partials/overviews/emp/gmf-employee-appreciation.html',
            controller: 'publicOverviewController',
            controllerAs: 'POVC'
          }
        }
      })
      .state('overview.gmfexec', {
        url: 'gmfexec/',
        pageTitle: 'Overview | Executive Purchase Program',
        programCode: 'gmfexec',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one': {
            templateUrl: '/content/html/partials/overviews/emp/gmf-executive-purchase.html',
            controller: 'publicOverviewController',
            controllerAs: 'POVC'
          }
        }
      })
      .state('overview.mktexec', {
        url: 'mkt-exec/',
        pageTitle: 'Overview | Executive Purchase Program',
        programCode: 'mktexec',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one': {
            templateUrl: '/content/html/partials/overviews/emp/gm-executive-purchase.html',
            controller: 'publicOverviewController',
            controllerAs: 'POVC'
          }
        }
      })
      .state('overview.gmsani', {
        url: 'gmsani/',
        pageTitle: 'Overview | GM Employee Accessory Distributor Discount',
        programCode: 'gmsani',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one': {
            templateUrl: '/content/html/partials/overviews/emp/gm-employee-accessory-distributor-discount.html',
            controller: 'publicOverviewController',
            controllerAs: 'POVC'
          }
        }
      })
      .state('overview.usexec', {
        url: 'usexec/',
        pageTitle: 'Overview | Executive Purchase Program',
        programCode: 'usexec',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one': {
            templateUrl: '/content/html/partials/overviews/emp/gm-executive-purchase.html',
            controller: 'publicOverviewController',
            controllerAs: 'POVC'
          }
        }
      })
      .state('overview.gmappcert5', {
        url: 'gmappcert5/',
        pageTitle: 'Overview | Employee Appreciation Certificate',
        programCode: 'gmappcert5',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one': {
            templateUrl: '/content/html/partials/overviews/emp/gmappcert5-discount.html',
            controller: 'publicOverviewController',
            controllerAs: 'POVC'
          }
        }
      })
      .state('overview.gmappcert6', {
        url: 'gmappcert6/',
        pageTitle: 'Overview | Employee Appreciation Certificate',
        programCode: 'gmappcert6',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one': {
            templateUrl: '/content/html/partials/overviews/emp/gmappcert5-discount.html',
            controller: 'publicOverviewController',
            controllerAs: 'POVC'
          }
        }
      })
      .state('overview.gmappcert7', {
        url: 'gmappcert7/',
        pageTitle: 'Overview | Employee Appreciation Certificate',
        programCode: 'gmappcert7',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one': {
            templateUrl: '/content/html/partials/overviews/emp/gmappcert5-discount.html',
            controller: 'publicOverviewController',
            controllerAs: 'POVC'
          }
        }
      })
      .state('overview.gmfappcert5', {
        url: 'gmfappcert5/',
        pageTitle: 'Overview | Employee Appreciation Certificate',
        programCode: 'gmfappcert5',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one': {
            templateUrl: '/content/html/partials/overviews/emp/gmfappcert5-discount.html',
            controller: 'publicOverviewController',
            controllerAs: 'POVC'
          }
        }
      })
      .state('overview.gmfappcert6', {
        url: 'gmfappcert6/',
        pageTitle: 'Overview | Employee Appreciation Certificate',
        programCode: 'gmfappcert6',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one': {
            templateUrl: '/content/html/partials/overviews/emp/gmfappcert5-discount.html',
            controller: 'publicOverviewController',
            controllerAs: 'POVC'
          }
        }
      })
      .state('overview.gmfappcert7', {
        url: 'gmfappcert7/',
        pageTitle: 'Overview | Employee Appreciation Certificate',
        programCode: 'gmfappcert7',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one': {
            templateUrl: '/content/html/partials/overviews/emp/gmfappcert5-discount.html',
            controller: 'publicOverviewController',
            controllerAs: 'POVC'
          }
        }
      })
      .state('overview.gmeac', {
        url: 'gmeac/',
        pageTitle: 'Overview | Employee Appreciation Certificate',
        programCode: 'gmeac',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one': {
            templateUrl: '/content/html/partials/overviews/emp/gmeac-discount.html',
            controller: 'publicOverviewController',
            controllerAs: 'POVC'
          }
        }
      })
      .state('overview.soty', {
        url: 'soty/',
        programCode: 'soty24',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one': {
            templateUrl: '/content/html/partials/overviews/sup/soty-discount.html',
            controller: 'publicOverviewController',
            controllerAs: 'POVC'
          }
        }
      })
      // .state('overview.sotyev', {
      //   url: 'soty/',
      //   pageTitle: 'Overview | Supplier of the Year',
      //   programCode: 'soty24ev',
      //   views: {
      //     '': {
      //       templateUrl: '/non-content/templates/row-one.html'
      //     },
      //     'brandBar': {
      //       templateUrl: '/non-content/components/brand-bar.html',
      //       controller: 'brandBarController',
      //       controllerAs: 'BBC'
      //     },
      //     'row-one': {
      //       templateUrl: '/content/html/partials/overviews/sup/soty-ev-discount.html',
      //       controller: 'publicOverviewController',
      //       controllerAs: 'POVC'
      //     }
      //   }
      // })
      .state('overview.hbcash17', {
        url: 'hbcash/',
        pageTitle: 'Overview | GM Ceritified Service',
        programCode: 'hbcash17',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one': {
            templateUrl: '/content/html/partials/overviews/sup/holiday-bonus-cash.html',
            controller: 'publicOverviewController',
            controllerAs: 'POVC'
          }
        }
      })
      .state('overview.gmcs', {
        url: 'gmcs/',
        pageTitle: 'Overview | Holiday Bonus Cash',
        programCode: 'gmcs',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one': {
            templateUrl: '/content/html/partials/overviews/emp/gm-certified-service-discount.html',
            controller: 'publicOverviewController',
            controllerAs: 'POVC'
          }
        }
      })
      .state('overview.frd', {
        url: 'frd/',
        pageTitle: 'Overview | First Responders',
        programCode: 'frd',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one': {
            templateUrl: '/content/html/partials/overviews/frd/overview.html',
            controller: 'publicOverviewController',
            controllerAs: 'POVC'
          }
        }
      })
      .state('obtainauth', {
        url: '/obtainauth/',
        pageTitle: 'Authorization Authentication',
        pageID: '',
        authenticate: true,
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one@obtainauth': {
            templateUrl: '/non-content/components/kba.html',
            controller: 'kbaController',
            controllerAs: 'KBA'
            // Temporary Place holder for Row - Remove Template when ready.
            // template: "<div class='tempPlaceholder'>Row One get Authorizations Content Area</div>"
          }
        }
      })
      .state('get-auth', {
        url: '/get-authorization-number/',
        pageTitle: 'Get Authorization Number',
        pageID: '',
        authenticate: true,
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one@get-auth': {
            templateUrl: '/non-content/components/get-auth.html',
            controller: 'getAuthController',
            controllerAs: 'GAC'
            // Temporary Place holder for Row - Remove Template when ready.
            // template: "<div class='tempPlaceholder'>Row One get Authorizations Content Area</div>"
          }
        }
      })
      .state('get-auth-step2', {
        url: '/get-authorization-number/step-2/',
        pageTitle: 'Get Authorization Number',
        pageID: '',
        authenticate: true,
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one@get-auth-step2': {
            templateUrl: '/non-content/components/get-auth-step-2.html',
            controller: 'getAuthController',
            controllerAs: 'GAC'
            // Temporary Place holder for Row - Remove Template when ready.
            // template: "<div class='tempPlaceholder'>Row One get Authorizations Step 2 Content Area</div>"
          }
        }
      })
      .state('get-auth-complete', {
        url: '/get-authorization-number/complete/',
        pageTitle: 'Get Authorization Number',
        pageID: '',
        authenticate: true,
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one@get-auth-complete': {
            templateUrl: '/non-content/components/get-auth-complete.html',
            controller: 'getAuthController',
            controllerAs: 'GAC'
            // Temporary Place holder for Row - Remove Template when ready.
            // template: "<div class='tempPlaceholder'>Row One get Authorizations Complete Content Area</div>"
          }
        }
      })
      .state('contact-links', {
        url: '/contact-links/',
        pageTitle: 'Contacts',
        metaDescription: 'If you have a question or concern that isn\'t addressed in our FAQs, visit our website to submit a question.',
        pageID: '',
        canonical: domainPath + "/contact-links/",
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one@contact-links': {
            templateUrl: '/content/html/partials/global/contact-links.html',
            controller: 'contactLinksController',
            controllerAs: 'CLC'
          }
        }
      })
      .state('contact-us', {
        url: '/contact-us/',
        pageTitle: 'Contact Us',
        metaDescription: "Ask about the GM Discount Program. Just complete the form below and click \"submit\" when you're done.",
        pageID: '',
        canonical: domainPath + "/contact-us/",
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'brandBar-sub': {
            templateUrl: '/non-content/components/headline.html',
            controller: 'headlineController',
            controllerAs: 'CBBSC',
            resolve: {
              ssoUrl: function () {
                return {};
              }
            }
          },

          'row-one@contact-us': {
            templateUrl: '/non-content/components/contact-form.html',
            controller: 'contactFormController',
            controllerAs: 'CFC'
          }
        }
      })
      .state('contact-success', {
        url: '/contact-us/success/',
        // parent: 'contact-us',
        pageTitle: 'Thank you!',
        pageID: '',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one@contact-success': {
            templateUrl: '/non-content/components/contact-success.html'
          }
        }
      })
      .state('create-account', {
        url: '/create-an-account/',
        pageTitle: 'Create an Account',
        metaDescription: 'Create your Account by filling out the required fields below, you agree that GM may contact you with offers.',
        pageID: '',
        canonical: domainPath + "/create-an-account/",
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC',
          },
          'brandBar-sub': {
            templateUrl: '/non-content/components/headline.html',
            controller: 'headlineController',
            controllerAs: 'HLC',
            resolve: {
              ssoUrl: function (apiFactory) {
                return apiFactory.getSsoUrl();
              }
            }
          },
          'row-one@create-account': {
            templateUrl: '/non-content/components/create-account-step1.html',
            controller: 'createAccountController',
            controllerAs: 'CACST'
          }
        }
      })
      .state('create-account.step-2', {
        url: 'step-2/',
        pageTitle: 'Create an Account | Step 2',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'row-one': {
            templateUrl: '/non-content/components/create-account-step2.html',
            controller: 'createAccountController',
            controllerAs: 'CACST'
          }
        }
      })
      .state('create-account.step-3', {
        url: 'step-3/',
        pageTitle: 'Create an Account | Step 3',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'row-one': {
            templateUrl: '/non-content/components/create-account-step3.html',
            controller: 'createAccountController',
            controllerAs: 'CACST'
          }
        }
      })
      .state('sign-in', {
        url: '/sign-in/',
        pageTitle: 'Sign In',
        metaDescription: 'Please enter your user name and password to sign into your GM Discount account.',
        pageID: '',
        canonical: domainPath + "/sign-in/",
        views: {
          '': {
            templateUrl: '/non-content/templates/row-two.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'brandBar-sub': {
            templateUrl: '/non-content/components/headline.html',
            controller: 'headlineController',
            controllerAs: 'HLC',
            resolve: {
              ssoUrl: function () {
                return {};
              }
            }
          },
          'row-one@sign-in': {
            templateUrl: '/non-content/components/signin.html',
            controller: 'signInController',
            controllerAs: 'SIC'
          },
        }
      })
      .state('sign-in-notice', {
        url: '/sign-in-notice/',
        pageTitle: 'Account Notice',
        metaDescription: 'Please enter your user name and password to sign into your GM Discount account.',
        canonical: domainPath + "/sign-in-notice/",
        pageID: '',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one@sign-in-notice': {
            templateUrl: '/non-content/components/signin-notice.html',
            controller: 'signInNoticeController',
            controllerAs: 'SIC'
          }
        }
      })
      .state('account-migration-step2', {
        url: '/account-migration-step2/',
        pageTitle: 'Account Notice',
        metaDescription: 'Check if account exists.',
        pageID: '',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'brandBar-sub': {
            templateUrl: '/non-content/components/headline.html',
            controller: 'headlineController',
            controllerAs: 'HLC',
            resolve: {
              ssoUrl: function (apiFactory) {
                return apiFactory.getSsoUrl();
              }
            }
          },
          'row-one@account-migration-step2': {
            templateUrl: '/non-content/components/account-migration-step2.html',
            controller: 'accountMigrationStep2Controller',
            controllerAs: 'IPC'
          }
        }
      })
      .state('account-verification', {
        url: '/account-verification/',
        pageTitle: 'Account Verification Notice',
        metaDescription: 'Account Email Notice.',
        pageID: '',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'brandBar-sub': {
            templateUrl: '/non-content/components/headline.html',
            controller: 'accountVerificationController',
            controllerAs: 'AVC',
            resolve: {
              ssoUrl: function (apiFactory) {
                return apiFactory.getSsoUrl();
              }
            }
          },
          'row-one@account-verification': {
            templateUrl: '/non-content/components/account-verification.html',
            controller: 'accountVerificationController',
            controllerAs: 'AVC'
          }
        }
      })
      .state('confirm-username', {
        url: '/confirm-username/',
        pageTitle: 'Confirm Username',
        metaDescription: 'Please enter your new user name and password to confirm your new user name',
        pageID: '',
        canonical: domainPath + "/confirm-username/",
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'brandBar-sub': {
            templateUrl: '/non-content/components/headline.html',
            controller: 'headlineController',
            controllerAs: 'HLC',
            resolve: {
              ssoUrl: function () {
                return {};
              }
            }
          },
          'row-one@confirm-username': {
            templateUrl: '/non-content/components/confirm-username.html',
            controller: 'confirmUsernameController',
            controllerAs: 'CUC'
          }
        }
      })
      .state('saml-error', {
        url: '/saml/error/',
        pageTitle: 'Saml Error',
        metaDescription: '',
        pageID: '',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'brandBar-sub': {
            templateUrl: '/non-content/components/headline.html',
            controller: 'headlineController',
            controllerAs: 'HLC',
            resolve: {
              ssoUrl: function () {
                return {};
              }
            }
          },
          'row-one@saml-error': {
            templateUrl: '/content/html/partials/global/server-errors.html'
          }
        }
      })
      .state('sign-out', {
        url: '/sign-out/',
        pageTitle: 'Sign Out',
        pageID: '',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'brandBar-sub': {
            templateUrl: '/non-content/components/headline.html',
            controller: 'headlineController',
            controllerAs: 'HLC',
            resolve: {
              ssoUrl: function () {
                return {};
              }
            }
          },
          'row-one@sign-out': {
            template: "<div class='tempPlaceholder'>Sign Out Page - You have been Signed Out</div>"
          }
        }
      })
      .state('more-offers', {
        url: '/view-more-offers/',
        pageTitle: '',
        pageID: '',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'row-one@more-offers': {
            templateUrl: ''
          }
        }
      })
      .state('family-legacy', {
        url: '/family-legacy/',
        pageTitle: '',
        pageID: '',
        canonical: domainPath + "/family-legacy/",
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'subNav': {
            templateUrl: '/content/html/partials/global/nav-subnav.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'brandBar-sub': {
            templateUrl: '/non-content/components/headline.html',
            controller: 'headlineController',
            controllerAs: 'CBBSC',
            resolve: {
              ssoUrl: function () {
                return {};
              }
            }
          },
          'row-one@family-legacy': {
            templateUrl: '/content/html/partials/share/' + domainAbbr + '/family-legacy.html'
          }
        }
      })
      .state('legacy', {
        url: '/legacy/',
        pageTitle: 'Family Legacy Program',
        metaDescription: 'Please follow these steps to go through the application process to determine your eligibility for the Family Legacy Program.',
        pageID: '',
        canonical: domainPath + "/legacy/",
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'subNav': {
            templateUrl: '/content/html/partials/global/nav-subnav.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one@legacy': {
            templateUrl: '/content/html/partials/share/' + domainAbbr + '/legacy.html',
            controller: 'legacyController',
            controllerAs: 'LC'
          }
        }
      })
      .state('nonGMDealershipEmployeeAuth', {
        url: '/nonGMDealershipEmployeeAuth/',
        pageTitle: 'Family Legacy Program',
        metaDescription: 'Please follow these steps to go through the application process to determine your eligibility for the Family Legacy Program.',
        pageID: '',
        canonical: domainPath + "/nonGMDealershipEmployeeAuth/",
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'subNav': {
            templateUrl: '/content/html/partials/global/nav-subnav.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one@nonGMDealershipEmployeeAuth': {
            templateUrl: '/content/html/partials/offers/' + domainAbbr + '/non-GM-dealership-employee-auth.html',
            controller: 'nonGMDealershipAuthController',
            controllerAs: 'NGMDA'
          }
        }
      })
      .state('about-buypowercard', {
        url: '/learn-more-about-buypower-card/',
        pageTitle: '',
        pageID: '',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'row-one@about-buypowercard': {
            templateUrl: ''
          }
        }
      })
      .state('motor-trend-2016', {
        url: '/motor-trend-truck-of-the-year-2016/',
        pageTitle: '',
        pageID: '',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'row-one@motor-trend-2016': {
            templateUrl: ''
          }
        }
      })
      .state('forgot-password', {
        url: '/forgot-password/',
        resolve: {
          redirect: ['$location', function ($location) {
            if (domainAbbr === 'ded') {
              $location.path('/sign-in/')
            }
            if (domainAbbr === 'sup' || domainAbbr === 'cgp' || domainAbbr === 'mpp') {
              $location.path('/sign-in-notice/')
            }
          }]
        }
      })
      //   pageTitle: 'Forgot Password',
      //   metaDescription: 'To reset your password, simply complete the following three steps and your password will be reset.',
      //   pageID: '',
      //   canonical: domainPath + "/forgot-password/",
      //   views: {
      //     '': {
      //       templateUrl: '/non-content/templates/row-one.html'
      //     },
      //     'brandBar': {
      //       templateUrl: function() {
      //         if (domainAbbr === 'mpp') {
      //           return '/non-content/components/brand-bar.html';
      //         } else {
      //           return;
      //         }
      //       },
      //       controller: 'brandBarController',
      //       controllerAs: 'BBC'
      //     },
      //     'brandBar-sub': {
      //       templateUrl: function() {
      //         if (domainAbbr === 'mpp') {
      //           return;
      //         } else {
      //           return '/non-content/components/headline.html';
      //         }
      //       },
      //       controller: 'headlineController',
      //       controllerAs: 'HLC',
      //       resolve: {
      //         ssoUrl: function() {
      //           return {};
      //         }
      //       }
      //     },
      //     'row-one@forgot-password': {
      //       templateUrl: function() {
      //         if (domainAbbr === 'mpp') {
      //           return '/non-content/components/idMeUserName.html';
      //         } else {
      //           return '/non-content/components/forgotPassword-step1.html';
      //         }
      //       },
      //       controller: 'ForgotPasswordController'
      //     }
      //   }
      // })
      // .state('forgot-password.step-2', {
      //   url: 'step-2/',
      //   pageID: '',
      //   views: {
      //     '': {
      //       templateUrl: '/non-content/templates/row-one.html'
      //     },
      //     'brandBar-sub': {
      //       templateUrl: '/non-content/components/headline.html',
      //       controller: 'headlineController',
      //       controllerAs: 'HLC',
      //       resolve: {
      //         ssoUrl: function() {
      //           return {};
      //         }
      //       }
      //     },
      //     'row-one@forgot-password': {
      //       templateUrl: '/non-content/components/forgotPassword-step2.html',
      //       controller: 'ForgotPasswordController'
      //     }
      //   }
      // })
      // .state('forgot-password.step-2-field', {
      //   url: 'step-2/{field}/',
      //   pageID: '',
      //   views: {
      //     '': {
      //       templateUrl: '/non-content/templates/row-one.html'
      //     },
      //     'brandBar-sub': {
      //       templateUrl: '/non-content/components/headline.html',
      //       controller: 'headlineController',
      //       controllerAs: 'HLC',
      //       resolve: {
      //         ssoUrl: function() {
      //           return {};
      //         }
      //       }
      //     },
      //     'row-one@forgot-password': {
      //       templateUrl: '/non-content/components/forgotPassword-step2.html',
      //       controller: 'ForgotPasswordController'
      //     }
      //   }
      // })
      // .state('forgot-password.step-3', {
      //   url: 'step-3/',
      //   pageTitle: 'Success!',
      //   pageID: '',
      //   views: {
      //     '': {
      //       templateUrl: '/non-content/templates/row-one.html'
      //     },
      //     'brandBar-sub': {
      //       templateUrl: '/non-content/components/headline.html',
      //       controller: 'headlineController',
      //       controllerAs: 'HLC',
      //       resolve: {
      //         ssoUrl: function() {
      //           return {};
      //         }
      //       }
      //     },
      //     'row-one@forgot-password': {
      //       templateUrl: '/non-content/components/forgotPassword-step3.html',
      //       controller: 'ForgotPasswordController'
      //     }
      //   }
      // })
      .state('forgot-password.expired', {
        url: 'expired/',
        pageTitle: 'Password Expired!',
        pageID: '',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar-sub': {
            templateUrl: '/non-content/components/headline.html',
            controller: 'headlineController',
            controllerAs: 'HLC',
            resolve: {
              ssoUrl: function () {
                return {};
              }
            }
          },
          'row-one@forgot-password': {
            templateUrl: '/non-content/components/forgotPassword-expired.html',
            controller: 'ForgotPasswordController'
          }
        }
      })
      .state('profile', {
        url: '/profile/',
        pageTitle: 'Profile',
        pageID: '',
        authenticate: true,
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'brandBar-sub': {
            templateUrl: '/non-content/components/headline.html',
            controller: 'headlineController',
            controllerAs: 'HLC',
            resolve: {
              ssoUrl: function () {
                return {};
              }
            }
          },
          'row-one@profile': {
            templateUrl: '/non-content/components/profile.html',
            controller: 'ProfileController'
          }
        }
      })
      .state('dealer-locator', {
        url: '/dealer-locator/',
        pageTitle: '',
        pageID: '',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar-sub': {
            templateUrl: '/non-content/components/headline.html',
            controller: 'headlineController',
            controllerAs: 'HLC',
            resolve: {
              ssoUrl: function () {
                return {};
              }
            }
          },
          'row-one@dealer-locator': {
            templateUrl: '/non-content/components/dealer-locator.html',
            controller: 'DealerLocatorController'
          }
        }
      })
      .state('vehicle-search', {
        url: '/vehicle-search/',
        pageTitle: 'Vehicle Search',
        pageID: '',
        authenticate: true,
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html',
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one@vehicle-search': {
            templateUrl: '/non-content/components/vehicle-tagging-ev.html',
            controller: 'vehicleTaggingEvController',
            controllerAs: 'VTC',
          },
          breadcrumb: {
            title: 'Search Vehicles'
          }
        }
      })
      .state('available-vehicles', {
        url: '/available-vehicles/',
        pageTitle: 'Available Vehicles',
        pageID: '',
        authenticate: true,
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one@available-vehicles': {
            templateUrl: '/non-content/components/vehicle-tag-state.html',
            controller: 'vehicleTaggingController',
            controllerAs: 'VTC'
          },
          breadcrumb: {
            title: 'Available Vehicles'
          }
        }
      })
      .state('vehicle-tag-detail', {
        url: '/vehicle-tag-detail/',
        pageTitle: 'Vehicle Tag Detail',
        pageID: '',
        authenticate: true,
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html',
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one@vehicle-tag-detail': {
            templateUrl: '/non-content/components/vehicle-detail.html',
            controller: 'vehicleDetailController',
            controllerAs: 'VDC',
          },
          breadcrumb: {
            title: 'Vehicle Details'
          }
        }
      })
      .state('vehicle-tag-success', {
        url: '/vehicle-tag-success/',
        pageTitle: 'Vehicle Tag Confirm',
        pageID: '',
        authenticate: true,
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html',
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one@vehicle-tag-success': {
            templateUrl: '/non-content/components/vehicle-tag-success.html',
            controller: 'vehicleDetailController',
            controllerAs: 'VDC',
          }
        }
      })
      .state('account-audit', {
        url: '/account-audit/',
        pageTitle: 'Account Address Audit',
        pageID: '',
        authenticate: true,
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one@account-audit': {
            templateUrl: '/non-content/components/account-audit.html',
            controller: 'accountAuditController',
            controllerAs: 'AAC'
          }
        }
      })
      .state('address-edit', {
        url: '/address-edit/',
        pageTitle: 'Edit Address',
        pageID: '',
        authenticate: true,
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'brandBar': {
            templateUrl: '/non-content/components/brand-bar.html',
            controller: 'brandBarController',
            controllerAs: 'BBC'
          },
          'row-one@address-edit': {
            templateUrl: '/non-content/components/address-edit.html',
            controller: 'editAddressController',
            controllerAs: 'EAC'
          }
        }
      })
      .state('confirm', {
        url: '/confirm/',
        pageTitle: 'Email Confirmation',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html',
            controller: 'verifyUserController',
            controllerAs: 'VUC'
          }
        }
      })
      .state('changeMe', {
        url: '/change-me/',
        views: {
          '': {
            templateUrl: '/non-content/templates/row-one.html'
          },
          'row-one@changeMe': {
            templateUrl: '/content/html/partials/videos/video-test2.html'
          }
        }
      });

    $httpProvider.interceptors.push('ServerNodeIntercept');
    $httpProvider.interceptors.push('redirectIntercept');
    //$httpProvider.interceptors.push('SamlLogin');

  });
